// src/integrations/smartcar/manifest.js
import logo from './smartcar_black_logo.svg';

const smartcarManifest = {
  slug: 'smartcar',
  type: 'Integrations::SmartcarIntegration',
  displayName: 'Smartcar',
  asset_sync_message:
    'Sync imports vehicles already connected to your Smartcar application. Connect new vehicles in the Smartcar Dashboard first, then run sync.',
  logo,
  colorClass: 'bg-white',
};

export default smartcarManifest;
